import { Directive, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Decimal } from 'decimal.js';

@Directive({
    selector: 'input[pkpDecimal]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DecimalDirective),
            multi: true
        }
    ]
})
export class DecimalDirective implements ControlValueAccessor {
    private _value: Decimal;
    private element: HTMLInputElement;

    constructor(private el: ElementRef) {
        this.element = this.el.nativeElement as HTMLInputElement;
        this.element.addEventListener('input', (evt) => {
            try {
                this._value = new Decimal(this.element.value);
                this.onChange(this._value);
            } catch (e) {
                // pass through native value to properly trigger validation
                this.onChange(this.element.value);
            }
        });
        this.element.addEventListener('change', (evt) => {
            this.onTouched();
        });
    }

    public onChange: any = (_) => {
        /*Empty*/
    };
    public onTouched: any = () => {
        /*Empty*/
    };

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {}

    writeValue(obj: Decimal | any): void {
        if (obj && Decimal.isDecimal(obj)) {
            const decimal: Decimal = obj as Decimal;
            this._value = obj;
            this.element.value = decimal.toFixed();
        } else {
            this.element.value = '';
        }
    }
}
